
export const STORE_KEY = '@@invoice'
export const GET_INVOICE_META_REQUEST = `${STORE_KEY}/GET_INVOICE_META_REQUEST`
export const GET_INVOICE_META_SUCCESS = `${STORE_KEY}/GET_INVOICE_META_SUCCESS`
export const GET_INVOICE_META_FAILURE = `${STORE_KEY}/GET_INVOICE_META_FAILURE`
export const GET_INVOICE_PAYMENT_METHODS_REQUEST = `${STORE_KEY}/GET_INVOICE_PAYMENT_METHODS_REQUEST`
export const GET_INVOICE_PAYMENT_METHODS_SUCCESS = `${STORE_KEY}/GET_INVOICE_PAYMENT_METHODS_SUCCESS`
export const GET_INVOICE_PAYMENT_METHODS_FAILURE = `${STORE_KEY}/GET_INVOICE_PAYMENT_METHODS_FAILURE`
export const PAY_INVOICE_REQUEST = `${STORE_KEY}/PAY_INVOICE_REQUEST`
export const PAY_INVOICE_SUCCESS = `${STORE_KEY}/PAY_INVOICE_SUCCESS`
export const PAY_INVOICE_FAILURE = `${STORE_KEY}/PAY_INVOICE_FAILURE`
